const initialState = () => ({
  page_id: null,
  url: null,
  title: null
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    assign(state, { page_id = null, url = null, title = null } = {}) {
      state.page_id = page_id
      state.url = url
      state.title = title
    },
    reset(state) {
      Object.assign(state, initialState())
    }
  }
}
